import { render, staticRenderFns } from "./service-visual.vue?vue&type=template&id=2ff43481&scoped=true"
import script from "./service-visual.vue?vue&type=script&lang=js"
export * from "./service-visual.vue?vue&type=script&lang=js"
import style0 from "./service-visual.vue?vue&type=style&index=0&id=2ff43481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff43481",
  null
  
)

export default component.exports